import React, {useState, useEffect, useRef} from "react";
import classnames from "classnames/bind";
import _ from "lodash";
import QuickSearch, {QuickSearchRef} from "../FindTheRightOil/QuickSearch";
import VehicleSearch, {
  VehicleSearchRef,
} from "../FindTheRightOil/VehicleSearch";
import OilSearch from "../FindTheRightOil/OilSearch";
import LicensePlateSearch from "../FindTheRightOil/LicensePlateSearch";
import "../../../style/oil-search-styles.scss";
import style from "./index.module.scss";
import instance from "../../../services/httpRequest";
import {ISearchVehicle, Replacement} from "../../../interface";
import localesReplacement from "../../../utils/localesReplacement";
import IconOil from "../../../images/new-oil.svg";
import IconOilSelected from "../../../images/new-oil-selected.svg";
import IconOilTrade from "../../../images/new-oil-trade.svg";
import IconLicensePlate from "../../../images/new-license-plate-search.svg";
import IconLicensePlateSelected from "../../../images/new-license-plate-search-selected.svg";
import IconLicensePlateTrade from "../../../images/new-license-plate-search-trade.svg";
import IconClockFastrack from "../../../images/new-icon-clock-fastrack.svg";
import IconClockFastrackSelected from "../../../images/new-icon-clock-fastrack-selected.svg";
import IconClockFastrackTrade from "../../../images/new-icon-clock-fastrack-trade.svg";
import {AxiosResponse} from "axios";
import {
  APPNAME,
  ENABLEDWORKSHOPSOWNER,
  ENABLED_LICENSE_PLATE_COUNTRIES,
  FASTSCAN,
  NEW_UI_DISABLED_OILSEARCH,
  NORDICS,
  ANALYTICS_EVENT,
  ANALYTICS_PAGE_TYPE,
} from "../../../constants";

import {
  Variant,
  ENABLE_FORD_LICENSE_PLATE_COUNTRIES,
} from "../../../constants/variants";

import OwnerSelector from "../OwnerSelector";
import {isQuickSearchDisabled} from "../../../utils/isQuickSearchDisabled";
import UnderMaintenance from "../../UnderMaintenance";
import {isAU, isNZL} from "../../../utils";
import {connect} from "react-redux";
import {Dispatch} from "redux";
import actions from "../../../redux/actions";
import {useMediaQuery} from "react-responsive";
import {useAppName} from "../../../hooks/use-app-names";
import {useSearchParams} from "react-router-dom";
import {useAnalytics} from "../../../hooks/use-analytics";
const cx = classnames.bind(style);

interface IProps {
  country: string;
  i18n?: string;
  baseAPI?: string;
  locales?: Replacement;
  onVehicleSelect?: (
    value: string | number,
    model: string,
    vehicleType?: string
  ) => void;
  onProductSelect?: (value: string | number) => void;
  onWTBClick?: () => void;
  restore?: boolean;
  preserved?: boolean;
  mode: boolean;
  setMode: (v: boolean) => void;
  setResults: (v: ISearchVehicle[] | null) => void;
}

enum Selections {
  QUICK_SEARCH = "quicksearch",
  PLATE_SEARCH = "licenseplate",
  FLUID_SEARCH = "fluids",
}

enum Modes {
  TRADE = "trade",
}

const SEARCH_TITLE_QUICK_SEARCH = "Vehicle & Equipment";
const SEARCH_TITLE_VEHICLE_SEARCH = "Vehicle search";
const SEARCH_TITLE_OIL_SEARCH = "Fluid & Oil Search";
const SEARCH_TITLE_LICENSE_PLATE_SEARCH = "License Plate Search";
const SEARCH_TITLE_LICENSE_PLATE_SEARCH_NZ = "Check Your Oil";
const SEARCH_TITLE_LICENSE_PLATE_SEARCH_AU = "REGO-2-OIL";

const setDefaultProps = (
  baseAPI: string | undefined,
  country: string,
  i18n: string | undefined
) => {
  if (baseAPI) {
    instance.defaults.baseURL = baseAPI;
  }
  if (country) {
    _.assign(instance.defaults.headers, {countryCode: country});
  }
  if (i18n) {
    _.assign(instance.defaults.headers, {languageCode: i18n});
  }
};

const selectedTabIndex =
  sessionStorage.getItem("selectedType") === "true" ? true : false;

function TypeList(props: {
  replacements: Replacement;
  types: any[];
  restore?: boolean;
  searchType: string;
  setSearchType: (v: string) => void;
}) {
  const {replacements, types, restore, searchType, setSearchType} = props;
  return (
    <ul>
      {_.map(types, (t, index) => (
        <li className={cx(t.classname)} key={index}>
          <label>
            <input
              type="radio"
              name="search-type"
              value={t.title}
              onChange={() => {
                setSearchType(t.title);
                localStorage.setItem("searchTab", t.title);
                //  Checking the language code for baltic region
                if (
                  localStorage.getItem("languageCode") === "LAV" ||
                  localStorage.getItem("languageCode") === "EST" ||
                  localStorage.getItem("languageCode") === "LTU"
                ) {
                  sessionStorage.removeItem("oilSearchReloaded");
                }
                if (restore) {
                  sessionStorage.clear();
                  sessionStorage.setItem("searchTab", t.title);
                }
              }}
              checked={_.isEqual(searchType, t.title)}
            />
            <div className={cx("search-item")}>
              <div className={cx("bg")}></div>
              <img className={cx("icon")} src={t.icon} alt={t.alt} />
              <img
                className={cx("icon", "selected")}
                src={t.iconSelected}
                alt={t.alt}
              />
              <span>{localesReplacement(replacements, t.title)}</span>
            </div>
            {t.haveSeparator ? <div className={cx("separator")} /> : null}
          </label>
        </li>
      ))}
    </ul>
  );
}

function LicensePlateSearchHOC(
  props: IProps & {
    replacements: Replacement;
    smartSearch: boolean;
    searchType: string;
    recaptcha: boolean;
    licensePlateRegexes: string;
  }
) {
  const {
    country,
    replacements,
    i18n,
    mode,
    smartSearch,
    searchType,
    recaptcha,
    licensePlateRegexes,
    ...rest
  } = props;
  return (
    <>
      {(((_.includes(ENABLED_LICENSE_PLATE_COUNTRIES, country) ||
        !smartSearch) &&
        _.isEqual(searchType, SEARCH_TITLE_LICENSE_PLATE_SEARCH)) ||
        _.isEqual(searchType, SEARCH_TITLE_LICENSE_PLATE_SEARCH_AU) ||
        _.isEqual(searchType, SEARCH_TITLE_LICENSE_PLATE_SEARCH_NZ)) && (
        <LicensePlateSearch
          country={country}
          language={i18n}
          replacements={replacements}
          {...rest}
          selectedWorkshop={
            _.includes(ENABLEDWORKSHOPSOWNER, country) ? mode : false
          }
          captcha={recaptcha}
          licensePlateRegexes={licensePlateRegexes}
        />
      )}
    </>
  );
}

function FindTheRightOil(props: IProps) {
  const {
    baseAPI,
    country,
    i18n,
    locales,
    onWTBClick,
    restore,
    preserved,
    mode = selectedTabIndex,
    setMode,
    setResults,
    ...rest
  } = props;
  const isDesktopOrLaptop = useMediaQuery({minWidth: 1024});
  const isFastScan = useAppName(FASTSCAN);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchType, setSearchType] = useState<string>(
    SEARCH_TITLE_QUICK_SEARCH
  );

  const variant = searchParams.get("variant");
  const isFord = variant === Variant.FORD;

  // eslint-disable-next-line
  const defaultTypes = (mode: boolean) => {
    const QUICK_SEARCH = {
      title: SEARCH_TITLE_QUICK_SEARCH,
      icon: IconClockFastrack,
      alt: "icon click fastrack",
      iconSelected: mode ? IconClockFastrackTrade : IconClockFastrackSelected,
      classname: "quickSearch",
    };
    if (!_.includes(NEW_UI_DISABLED_OILSEARCH, country)) {
      return [
        QUICK_SEARCH,
        {
          title: SEARCH_TITLE_OIL_SEARCH,
          icon: IconOil,
          iconSelected: mode ? IconOilTrade : IconOilSelected,
          alt: "icon oil",
          classname: "oilSearch",
        },
      ];
    } else {
      return [QUICK_SEARCH];
    }
  };

  const [types, setTypes] = useState<any[]>(defaultTypes(mode));
  //Get vehicles & product data
  setDefaultProps(baseAPI, country, i18n);
  const [replacements, setReplacements] = useState<Replacement>({});
  useEffect(() => {
    if (locales) {
      setReplacements(locales);
    }
  }, [locales]);

  useEffect(() => {
    setTypes(defaultTypes(mode));
  }, [mode]);

  const window: any = globalThis;

  const controller = new AbortController();
  const [licenseSearchEnabled, setLicenseSearchEnabled] =
    useState<boolean>(false);
  const [licence, setLicence] = useState<boolean>(false);
  const [recaptcha, setRecaptcha] = useState<boolean>(false);
  const [smartSearch, setSmartSearch] = useState<boolean>(true);
  const [licensePlateRegexes, setLicensePlateRegexes] = useState<string>("");
  const [type, setType] = useState<string>("");
  const [wtb, setWtb] = useState<boolean>(false);
  const [underMaintnance, setUnderMaintenance] = useState<boolean>(false);

  const sendAnalytics = useAnalytics();

  useEffect(() => {
    sendAnalytics({
      event: ANALYTICS_EVENT.PRODUCT_FINDER_VIEW,
      page: ANALYTICS_PAGE_TYPE.PRODUCT_FINDER,
      country: country,
      // user is not required as page view is independant of retail or trade
    });
  }, []);

  const isLicenseSearchEnabled = () => {
    if (isFord) {
      return ENABLE_FORD_LICENSE_PLATE_COUNTRIES.includes(country);
    } else {
      return (
        ENABLED_LICENSE_PLATE_COUNTRIES.includes(country) ||
        (!smartSearch && licenseSearchEnabled)
      );
    }
  };

  useEffect(() => {
    if (isLicenseSearchEnabled()) {
      const usaTypes = [...defaultTypes(mode)];
      usaTypes.splice(1, 0, {
        title: isNZL(country)
          ? SEARCH_TITLE_LICENSE_PLATE_SEARCH_NZ
          : isAU(country)
          ? SEARCH_TITLE_LICENSE_PLATE_SEARCH_AU
          : SEARCH_TITLE_LICENSE_PLATE_SEARCH,
        icon: IconLicensePlate,
        iconSelected: mode ? IconLicensePlateTrade : IconLicensePlateSelected,
        alt: "icon license plate",
        classname: "licensePlateSearch",
      });
      setTypes(usaTypes);
    } else {
      setTypes(defaultTypes(mode));
    }

    if (_.isEqual(country, "TUR")) {
      setSearchType(SEARCH_TITLE_VEHICLE_SEARCH);
    }
    if (NORDICS.includes(country)) {
      setSearchType(SEARCH_TITLE_LICENSE_PLATE_SEARCH);
    }
    // checking for baltic region
    if (
      location.pathname.includes("/baltic-region/") &&
      location.pathname.includes("/wtb-site-tunnel/")
    ) {
        searchParams.get('page') === 'landing' ? 
        setSearchType(SEARCH_TITLE_OIL_SEARCH) : 
        setSearchType(SEARCH_TITLE_QUICK_SEARCH);
      }
  }, [smartSearch, mode, country, licenseSearchEnabled]);

  useEffect(() => {
    instance
      .get("/data/countrySettings/currentCountrySetting", {
        signal: controller.signal,
      })
      .then((d: AxiosResponse) => {
        if (d) {
          setLicence(d.data.licensePlateSearchEnabled);
          setRecaptcha(d.data.captchaEnabled);
          setSmartSearch(d.data.enableSmartSearch);
          setLicensePlateRegexes(d.data.licensePlateRegexes);
          setType(d.data.serviceProvider);
          setWtb(d.data.whereToBuyForLandingEnabled);
          setLicenseSearchEnabled(d.data.licensePlateSearchEnabled);
        }
      });
    return () => {
      controller.abort();
    };
  }, []);

  //Restore from sessionStorage
  useEffect(() => {
    if (preserved) {
      setSearchType(
        sessionStorage.getItem("searchTab") ?? SEARCH_TITLE_QUICK_SEARCH
      );
    }
  }, [preserved]);

  useEffect(() => {
    const licensePlateSearches = [
      SEARCH_TITLE_LICENSE_PLATE_SEARCH,
      SEARCH_TITLE_LICENSE_PLATE_SEARCH_AU,
      SEARCH_TITLE_LICENSE_PLATE_SEARCH_NZ,
    ];
    if (searchParams.has("selection")) {
      switch (searchParams.get("selection")) {
        case Selections.QUICK_SEARCH:
          setSearchType(SEARCH_TITLE_QUICK_SEARCH);
          break;
        case Selections.PLATE_SEARCH:
          if (types.find((item) => licensePlateSearches.includes(item.title))) {
            setSearchType(
              types.find((item) => licensePlateSearches.includes(item.title))
                .title
            );
          }
          break;
        case Selections.FLUID_SEARCH:
          if (
            types.find((item) => item.title.startsWith(SEARCH_TITLE_OIL_SEARCH))
          ) {
            setSearchType(
              types.find((item) =>
                item.title.startsWith(SEARCH_TITLE_OIL_SEARCH)
              ).title
            );
          }
          break;
        default:
          setSearchType(SEARCH_TITLE_QUICK_SEARCH);
          break;
      }
    }
  }, [searchParams, types]);

  useEffect(() => {
    if (searchParams.has("mode")) {
      if (searchParams.get("mode") === Modes.TRADE) {
        setMode(true);
      } else {
        setMode(false);
      }
    }
  }, [searchParams]);

  useEffect(() => {
    instance
      .get("/categories", {
        signal: controller.signal,
      })
      .then((d: AxiosResponse) => {
        if (d.status !== 200) {
          // enable site under maintenance message
          setUnderMaintenance(true);
        }
      });
    return () => {
      controller.abort();
    };
  }, []);

  const quickSearchRef = useRef<QuickSearchRef>(null);
  const vehicleSearchRef = useRef<VehicleSearchRef>(null);
  return (
    <div className={cx("section", "castrol-oil-search")} id="oil-search">
      <div className={cx("heading")}>
        <h3>{localesReplacement(replacements, "Find the right product")}</h3>
        <p>
          {localesReplacement(
            replacements,
            "With the Castrol Product Finder it has never been easier to find out which oil is best for you."
          )}
        </p>
      </div>
      {underMaintnance ? (
        <div>
          <UnderMaintenance replacements={replacements} />
        </div>
      ) : (
        <>
          {country && _.includes(ENABLEDWORKSHOPSOWNER, country) && !isFord ? (
            <div className={cx("owner-selector")}>
              <OwnerSelector
                replacements={replacements}
                selectedIndex={mode}
                setSelectedIndex={(b) => {
                  sendAnalytics({
                    event: b
                      ? ANALYTICS_EVENT.WORKSHOP_OWNER_CLICKS
                      : ANALYTICS_EVENT.VEHICLE_OWNER_CLICKS,
                    country: country,
                  });
                  setMode(b);
                  sessionStorage.setItem("selectedType", _.toString(b));
                }}
              />
            </div>
          ) : null}
          <div className={cx("search-content")}>
            <div className={cx("search-type")}>
              <TypeList
                replacements={replacements}
                types={types}
                restore={restore}
                searchType={searchType}
                setSearchType={(v) => {
                  setResults(null);
                  setSearchType(v);
                  if (isDesktopOrLaptop) {
                    searchParams.delete("id");
                    searchParams.set("page", "landing");
                    isFastScan && searchParams.set(APPNAME, FASTSCAN);
                    setSearchParams(searchParams);
                  }
                }}
              />
              {wtb && onWTBClick && !restore && (
                <button
                  hidden
                  onClick={() => {
                    onWTBClick && onWTBClick();
                  }}
                >
                  {localesReplacement(replacements, "Where to Buy")}
                </button>
              )}
            </div>
            <div className={cx("content")}>
              {_.isEqual(searchType, SEARCH_TITLE_QUICK_SEARCH) && (
                <>
                  <QuickSearch
                    language={i18n}
                    replacements={replacements}
                    switchVehicleSearch={() =>
                      setSearchType(SEARCH_TITLE_VEHICLE_SEARCH)
                    }
                    country={country}
                    licence={licence && smartSearch}
                    licensePlateRegexes={licensePlateRegexes}
                    selectedWorkshop={
                      _.includes(ENABLEDWORKSHOPSOWNER, country) ? mode : false
                    }
                    captcha={recaptcha}
                    restore={restore}
                    preserved={preserved}
                    userType={mode}
                    ref={quickSearchRef}
                    isExtendedRestApi={false}
                    searchHandler={() => {
                      vehicleSearchRef.current &&
                        vehicleSearchRef.current.clearValue();
                    }}
                    {...rest}
                  />
                  {!isQuickSearchDisabled(country) && (
                    <span className={cx("or-separator")}>
                      {localesReplacement(replacements, "OR")}
                    </span>
                  )}
                  <div className={cx("vehicle-content")}>
                    <VehicleSearch
                      country={country}
                      replacements={replacements}
                      {...rest}
                      categoriesType={type}
                      selectedWorkshop={
                        _.includes(ENABLEDWORKSHOPSOWNER, country)
                          ? mode
                          : false
                      }
                      restore={restore}
                      preserved={preserved}
                      ref={vehicleSearchRef}
                      quickSearch={quickSearchRef}
                      searchHandler={() => {
                        quickSearchRef.current &&
                          quickSearchRef.current.clearValue();
                      }}
                    />
                  </div>
                </>
              )}
              {_.isEqual(searchType, SEARCH_TITLE_OIL_SEARCH) && (
                <div className={cx("oil-content")}>
                  <OilSearch
                    country={country}
                    replacements={replacements}
                    {...rest}
                    selectedWorkshop={
                      _.includes(ENABLEDWORKSHOPSOWNER, country) ? mode : false
                    }
                    restore={restore}
                    preserved={preserved}
                  />
                </div>
              )}
              <LicensePlateSearchHOC
                replacements={replacements}
                smartSearch={smartSearch}
                searchType={searchType}
                recaptcha={recaptcha}
                licensePlateRegexes={licensePlateRegexes}
                {...props}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setResults: (vehicle: ISearchVehicle[] | null) =>
    dispatch(actions.setResults(vehicle)),
  setLoading: (v: boolean) => dispatch(actions.setLoading(v)),
});

export default connect(null, mapDispatchToProps)(FindTheRightOil);
